import { CHART_CATALOG } from '../catalog/chartCatalog';
import { isCatalogIssueChartId } from './catalogIssueCharts';

type InspectionChartCatalogEntry = Extract<
  (typeof CHART_CATALOG)[number],
  { section: 'inspections'; enabled: true }
>;

export type CatalogInspectionChartId = InspectionChartCatalogEntry['id'];

export const CATALOG_INSPECTION_CHART_IDS = CHART_CATALOG.filter(
  (entry) => entry.section === 'inspections' && entry.enabled
).map((entry) => entry.id) as readonly CatalogInspectionChartId[];

export function isCatalogInspectionChartId(
  id: string
): id is CatalogInspectionChartId {
  return (CATALOG_INSPECTION_CHART_IDS as readonly string[]).includes(id);
}

export function isCatalogChartId(id: string): boolean {
  return isCatalogIssueChartId(id) || isCatalogInspectionChartId(id);
}

export const INSPECTION_TRIPLET_CHART_ID =
  'inspectionTriplet' satisfies CatalogInspectionChartId;
